import { FC, ReactElement, CSSProperties } from 'react';
import { Severity } from '@agilelab/plugin-wb-governance-common';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import WarningIcon from '@material-ui/icons/WarningOutlined';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface Props {
  severity: Severity;
  style?: CSSProperties;
}

interface SeverityProps {
  label: string;
  icon: ReactElement;
  color: string;
  style?: CSSProperties;
}

const SeverityElement: FC<SeverityProps> = ({ label, icon }) => {
  return (
    <>
      {icon}
      <Typography style={{ fontSize: 12 }}>{label}</Typography>
    </>
  );
};

export const GovernanceRegistryPoliciesSeverity: FC<Props> = ({
  severity,
  style,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const severityComponent: Record<Severity, ReactElement> = {
    [Severity.Error]: (
      <SeverityElement
        label="Error"
        icon={<ErrorIcon />}
        color={theme.palette.error.main}
      />
    ),
    [Severity.Info]: (
      <SeverityElement
        label="Info"
        icon={<InfoIcon />}
        color={theme.palette.info.main}
      />
    ),
    [Severity.Warning]: (
      <SeverityElement
        label="Warning"
        icon={<WarningIcon />}
        color={theme.palette.warning.main}
      />
    ),
  };

  return (
    <Box
      color={theme.palette[severity].main}
      className={classes.container}
      style={style}
    >
      {severityComponent[severity]}
    </Box>
  );
};
